<template>
  <div class="notification is-unselectable" :class="type">
    <button
      class="delete"
      @click="$emit('delete')"
      v-if="!withoutDelete"
    ></button>
    <icon :name="icon" v-if="icon" clas="is-size-4" />
    <slot />
  </div>
</template>

<script>
import { Icon } from "%helpers";

const SNACKBAR_TIMEOUT = 3000;

export default {
  name: "notification",

  components: {
    Icon
  },

  props: {
    type: String,
    icon: String,
    withoutDelete: Boolean,
    snackbar: [Boolean, Number]
  },

  mounted() {
    this.snackbar &&
      setTimeout(
        () => this.$emit("delete"),
        typeof this.snackbar === "boolean"
          ? SNACKBAR_TIMEOUT
          : this.snackbar * 1000
      );
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  align-items: flex-start;

  .icon {
    margin-right: 1rem;
  }
}
</style>
